import {DetailDialogController} from '../../../controller/DetailDialogController';
import { CONSOLIDATION_CURRENCY_PARAMS } from '../../../controller/CommonViewController';
import moment from 'moment';
import {
    USER_ACC,
    userReports,
    accounts,
    userReportfiles,
    VALUE_SERIES, ENUMS
} from '../../../services/arsweb/RoutingPaths';

import './userReport.html';
import './detail.html';
import {BackendService} from "../../../services/BackendService";
import {SearchableItemService} from "../../../services/SearchableItemService";
import {REPORT_TYPE} from "../../../components/report/ReportModalController";
import {TAB_BANK, TAB_COUNTRY, TAB_CURRENCY, TAB_GROUP} from "../../accounts/overview";
import {ExportService} from "../../../services/export/ExportService";
import {ArsConfig} from "../../../config/arsConfig.factory";
import {levelOptionClass} from "../../../services/arsweb/ClassType";
import {PDF_TYPE} from "../../../components/export/ExportModalController";

export const statementOptions = {value: 'STATEMENTS', maxRange: 93, min: -60, max: 0,
    options: [REPORT_TYPE.MT940_STATEMENTS, REPORT_TYPE.PDF_STATEMENTS_COMBINED, REPORT_TYPE.PDF_STATEMENTS_SEPARATED,
        REPORT_TYPE.XLSX_TRANSACTION_REPORT, REPORT_TYPE.CSV_TRANSACTION_REPORT]};
export const intradayOptions = {value: 'INTRADAYS',
    options: [REPORT_TYPE.MT942_INTRADAYS, REPORT_TYPE.PDF_INTRADAYS, REPORT_TYPE.XLS_TRANSACTION_INTRADAY_REPORT,
        REPORT_TYPE.CSV_TRANSACTION_INTRADAY_REPORT]};
export const valueSeriesRange = {maxRange: 60, min: -59, max: 0, futureMin: 0, futureMax: 59};
export const valueSeriesSummaryRange_PDF = {maxRange: 5, min: -4, max: 4, futureMin: 0, futureMax: 4};
export const valueSeriesSummaryRange_CSV = {maxRange: 31, min: -30, max: 30, futureMin: 0, futureMax: 30};
export const valueSeriesOptions = {value: 'VALUESERIES_BALANCES',
    options: [REPORT_TYPE.PDF_VALUESERIES, REPORT_TYPE.PDF_VALUESERIES_COMBINED, REPORT_TYPE.PDF_VALUESERIES_SUMMARY,
        REPORT_TYPE.CSV_VALUESERIES_SUMMARY, REPORT_TYPE.XLS_VALUESERIES_SUMMARY]};

export const FILE_TYPE_OPTIONS = [statementOptions, intradayOptions, valueSeriesOptions];
export const RANGE = 'RANGE';
export const DAYS = 'DAYS';
export const LAST = 'LAST';
export const DEFAULT_LEVEL = 'PRIVATE';

/** @ngInject */
export class UserReportDetailDialogController extends DetailDialogController {

    constructor($scope, userService, arsMainDependencies, createOrUpdateFunction) {

        super($scope, userService, arsMainDependencies, userReports, new BackendService(userService));
        this.exportService = new ExportService(ArsConfig, userService);
        this.createOrUpdateFunction = createOrUpdateFunction;
        this.fileTypeOptions = FILE_TYPE_OPTIONS;
        this.timeOutMills = arsMainDependencies.ArsConfig.timeOutMills;
        this.userService = userService;
        this.isValueSeries = window.location.href.endsWith(VALUE_SERIES);
        userService.fsMainDependencies.initCompletedPromise
            .then(() => new SearchableItemService(userService).getSearchableItems($scope))
            .then(() => this.initOptions(new BackendService(userService)));
    }

    initOptions(backendService){
        const accURL = this.isValueSeries ? VALUE_SERIES + accounts : accounts;
        this.filterOptions = [
            {value: 'ACCOUNTS', translationKey: 'ACCOUNTS', url: USER_ACC + accURL, kind: 'account', sort: this.state._params.sort}, // no options backend call
            {value: 'GROUPS', options: this.getKindFromSelection(TAB_GROUP), translationKey: 'ACCOUNT_GROUPS', kind: 'group'},
            {value: 'CURRENCIES', options: this.getKindFromSelection(TAB_CURRENCY), translationKey: 'CURRENCIES', kind: 'currency'},
            {value: 'COUNTRIES', options: this.getKindFromSelection(TAB_COUNTRY), translationKey: 'COUNTRIES', kind: 'country'},
            {value: 'BANKS', options: this.getKindFromSelection(TAB_BANK), translationKey: 'BANKS', kind: 'bank'}];

        this.secondaryGroups = [
            {value: 'NONE', translationKey: 'NONE'},
            {value: 'CURRENCIES', translationKey: 'CURRENCIES'},
            {value: 'COUNTRIES', translationKey: 'COUNTRIES'},
            {value: 'BANKS', translationKey: 'BANKS'}
        ];

        // load document type
        this.fileType = this.state._params.fileType ? this.state._params.fileType : FILE_TYPE_OPTIONS[0];
        this.fileOptionType = this.fileType.options[0];
        const filter = this.state._params.group ? this.state._params.group.kind : this.filterOptions[0].kind;
        // load options from accounts / details/ groups / valueseries views
        this.filterType = this.filterOptions.filter(option => option.kind === filter)[0];
        if(this.state._params && this.state._params.fileType){
            this.initFromParams(this.state._params);
        }
        // edit controller inits the promise
        if(typeof this.detailviewDataPromise.then === 'function') {
            this.detailviewDataPromise.then(() => this.loadOptionSelection());
        }

        backendService.service.config.params.javaType = levelOptionClass;
        this.level = {};
        backendService.getUserData(ENUMS).then(data =>
            this.level.options = data.map(op => {return {option: op, label: op};}));
    }

    selectSecondaryGroup(subGroup){
        if(subGroup === 'NONE'){
            this.element.secondaryGroup = null;
            this.element.showAccounts = true;
            return;
        }
        this.element.secondaryGroup = subGroup;
    }

    getSecondaryGroupOptions(){
        return this.secondaryGroups.filter(option => option.value != this.filterType.value);
    }

    checkSecondaryGroup(){
        if(this.element.secondaryGroup === this.filterType.value){
            this.element.secondaryGroup = null;
        }
    }

    resetAdditionalOptions(){
        this.element.withStatementData = false;
        this.element.secondaryGroup = null;
        this.element.showAccounts = true;
        const defaultDayRange = this.fileOptionType.value === REPORT_TYPE.PDF_VALUESERIES_SUMMARY.value ? 4 : 10
        this.element.futureDays = defaultDayRange;
        this.element.dateRange.lowerBound = moment().subtract(defaultDayRange, 'days');
    }


    initFromParams(_params) {
        this.filterType.selectAll = _params.selectAll;
        if(!this.filterType.selectAll) {
            this.populateSelectionList(_params.group ? [_params.group.code] : _params.ids, this.filterType);
        }
    }

    getKindFromSelection(kind) {
        return this.$scope.searchableItems.filter(it => it.kind === kind);
    }

    save() {
        if(this.valid(false)) {
            this.formatElement();
            this.isProcessing = true;
            return super[this.createOrUpdateFunction]();
        }
    }

    execute() {
        if(this.valid(true)) {
           this.formatElement();
           const fileType = this.exportService.processByFileMime(this.element, this.fileOptionType);
           this.executeUserReportDownload(fileType.userFunction, fileType);
        }
    }

    validDates() {
        const diff = (this.filterDateType === RANGE ? moment(this.element.dateRange.upperBound)
                .diff(moment(this.element.dateRange.lowerBound),'days') :
                Math.abs(this.element.days) + Math.abs(this.element.futureDays)) + 1;
        if(diff < 0) {
            this.infoPop(this.translate.instant('RANGE_FROM_BEFORE_TO'));
            return false;
        }

        const type = this.fileType ? this.fileType : FILE_TYPE_OPTIONS[0];
        const isStatement = type.value === statementOptions.value;
        const maxRange = this.getRangeData(this.filterDateType === DAYS && isStatement ?  'min' : 'maxRange');
        let outOfRange = false;
        if(this.filterDateType === DAYS && isStatement) {
            // days undefined or higher than maxRange
            outOfRange = !this.element.days || Math.abs(this.element.days) > Math.abs(maxRange);
        } else if(Number.isNaN(diff) || diff > maxRange) {
            outOfRange = true;
        }
        if(outOfRange) {
            this.infoPop(this.translate.instant('DAYS_LIMIT', { daysLimit: maxRange}));
            return false;
        }
        return true;
    }

    valid(execute) {
        // calidate fileOptionType
        if(this.fileType.options.indexOf(this.fileOptionType) == -1) {
            this.infoPop('MISSING_MANDATORY');
            return false;
        }
        if(!this.$scope.detailForm.$valid ||
            this.filterType.selectionList === undefined || this.filterType.selectionList.length === 0) {

            if(this.filterType.selectionList === undefined || this.filterType.selectionList.length === 0) {
                this.infoPop('MISSING_MANDATORY');
                return false;
            }

            if(execute && this.$scope.detailForm.$error.required.length === 1 &&
                this.$scope.detailForm.$error.required[0].$name === 'reportName') {
                return this.validDates();
            } else {
                this.infoPop('MISSING_MANDATORY');
                return false;
            }
        }

        return this.validDates();
    }

    executeUserReportDownload(userFunction, fileType) {
        this.isProcessing = true;
        if(this.state._params.consolitationcurrency) {
            const consCurr = this.state._params.consolitationcurrency;
            this.service.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = consCurr.code ? consCurr.code : consCurr;
            if(this.isValueSeries) {
                this.service.service.config.params.sort = this.state._params.sort;
            }
        }

        this.service[userFunction](userReportfiles, this.element).then(data => {
            this.detailviewDataPromise = this.exportService
                .downloadFile(data, this.exportService.reportBody.title, fileType, this, userFunction);
        });
        return this.detailviewDataPromise;
    }

    resetScreen() {
        this.toDefault();
        this.isProcessing = false;
    }

    toDefault() {
        this.service = new BackendService(this.userService);
        delete this.element.mt94XBody;
        delete this.element.pdfBody;
        delete this.element.csvBody;
    }

    formatElement() {
        // report type and filter
        this.filterOptions.forEach(filterType => {
            this.element[filterType.value.toLowerCase()] = this.filterType.value === filterType.value ?
                  this.filterType.selectionList.map(el => el.id || el.code) : [];
        });
        if(this.fileOptionType) {
            this.element.documentType = this.fileOptionType.value;
            this.element.fileType = this.fileOptionType.fileMime;
        }

        // date type and filter
        if(this.filterDateType !== RANGE) { //  empty Range
            delete this.element.dateRange;
        }
        if(this.filterDateType !== DAYS) { //empty days
            this.element.days = 0;
            this.element.futureDays = 0;
        }
        this.element.lastStatement = this.filterDateType === LAST;
        if(this.element.secondaryGroup === 'NONE'){
            this.element.secondaryGroup = null;
        }
        if(this.element.access === DEFAULT_LEVEL) {
            this.element.editing = DEFAULT_LEVEL;
        }
    }

    populateSelectionList(list, av) {
        av.selectionList = av.url ? list : av.options.filter(opt => (list.indexOf(opt.code) !== -1 || list.indexOf(opt.name) !== -1) );
    }

    getRangeData(field) {
        this.fileType = this.fileType ? this.fileType : FILE_TYPE_OPTIONS[0];
        return this.fileType.value === statementOptions.value ? this.fileType[field] :
           this.getValueSeriesRangeData(field);
    }

    getValueSeriesRangeData(field) {
        const rangeOptions = this.fileOptionType.fileMime === PDF_TYPE ?
            valueSeriesSummaryRange_PDF : valueSeriesSummaryRange_CSV;
        return valueSeriesOptions.options.indexOf(this.fileOptionType) <= 1 ?
            valueSeriesRange[field] : rangeOptions[field];
    }
}
